<template lang='pug'>
.my-container
    userCard
    .list-container
        .item(
            v-for='item in listData',
            :key='item.name',
            @click='jump(item.name)'
        )
            img(v-src='item.img')
</template>

<script>
import userCard from './components/userCard'
import { mapState } from 'vuex'
export default {
    name: 'my',
    data() {
        return {
            listData: [
                { name: 'address', img: 'https://oss.cloud.custouch.com/res/22290/收货地址.png' },
                { name: 'gift', img: 'https://oss.cloud.custouch.com/res/44653/积分兑换.png' },
                { name: 'collection', img: 'https://oss.cloud.custouch.com/res/22292/我的收藏.png' },
                { name: 'message', img: 'https://oss.cloud.custouch.com/res/22289/留言建议.png' },
                { name: 'binding', img: 'https://oss.cloud.custouch.com/res/22293/1688绑定.png' },
                { name: 'home', img: 'https://oss.cloud.custouch.com/res/22291/微网站主页.png' },
                { name: 'utils', img: 'https://oss.cloud.custouch.com/res/56258/会员中心-百宝箱.png' },
            ]
        }
    },
    components: {
        userCard
    },
    computed: {
        ...mapState(['memberInfo', 'userInfo', 'bookMarks', 'bookMarksLoading'])
    },
    methods: {
        jump(name) {
            if (name == 'message') {
                window.location.href =
                    window.env.VUE_APP_QUESTION_FORM +
                    `?redirect=${encodeURIComponent(window.location.href)}`
            } else {
                this.$router.push({ name: name })
            }
        }
    }
}
</script>

<style scoped lang='less'>
.list-container {
    padding: 1.4rem 1rem 0rem 1rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.2rem 1.9rem;
    .item {
        img {
            display: block;
            object-fit: cover;
            width: 100%;
        }
    }
}
</style>